import React, { PureComponent } from "react";
import WelcomeLayout from "../../layouts/welcome";

class TeamReportsSection3Step1 extends PureComponent {
  get title() {
    return (
      <span>
        Financial Planning &<br />
        Analysis
      </span>
    );
  }

  get right_content() {
    return <span>Did you meet expectations?</span>;
  }

  render() {
    return (
      <WelcomeLayout title={this.title} right_content={this.right_content} />
    );
  }
}

export default TeamReportsSection3Step1;



// WEBPACK FOOTER //
// ./src/components/team-reports/steps/section-3/step-1.js